<h5 class="p-16 m-0 bottomBorderStyle" id="bucket-items-transfer-lbl-title">Transfer</h5>

<div class="box" id="bucket-items-transfer-cnt-form">

  <div
    id="bucket-items-transfer-cnt-selected"
    class="selectedFilesContainer pos-relative m-0"
    >
    <div class="form-label m-b-m">SELECTED FOLDER(S)</div>

    <mat-chip-listbox
      #chipList
      id="bucket-items-transfer-cmp-selected-list"
      aria-label="packagefolder selection">

      @for (package of limitedpackagefolder; track package) {
        <mat-chip-option
          selectable="false"
          removable
          (removed)="remove(package)"
          [attr.id]="buildControlId('selected-package-chip', package?.Id)"
          >
          <span
            class="text-overflow-ellipsis chipclass selectedFileOptionFont"
            matTooltipClass="tooltip-style"
            matTooltipPosition="above"
            appMatTooltip="{{ package?.LeafName }}"
            [attr.id]="buildControlId('selected-package-label', package?.Id)"
            >
            {{ package?.LeafName }}
          </span>
          <button
            matChipRemove
            [attr.id]="buildControlId('selected-package-remove', package?.Id)"
            >
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-option>
      }

      @if (stringlength(packagefolder)) {
        <span
          id="bucket-items-transfer-btn-more-folders"
          (click)="overlaydisplay(packagefolder, $event)"
          class="color-link additionalpackageFolder"
          >
          +{{ packagefolder.length - 6 }} more
        </span>
      }

    </mat-chip-listbox>

    @if (chipList.errorState) {
      <mat-error>
        <span>Please select package folder(s) to transfer</span>
      </mat-error>
    }
  </div>

  <form class="singleselectdropdown" id="bucket-items-transfer-form">
    <mat-form-field class="singleselectdropdown" id="bucket-items-transfer-ddl-bucket" subscriptSizing="dynamic">
      <mat-label>Bucket Name</mat-label>

      <mat-select
        id="bucket-items-transfer-ddl-destination"
        [formControl]="DestinationPackageFolder"
        class="text-overflow-ellipsis"
        matTooltipClass="tooltip-style"
        matTooltipPosition="above"
        matTooltip="{{ bucketName }}"
        panelClass="transferComponent"
        hideSingleSelectionIndicator
        >
        @for (option of transferListOptions; track option) {
          <mat-option
            [value]="option.BucketId"
            class="text-overflow-ellipsis dropdown-display"
            [attr.id]="buildControlId('destination-option', option?.BucketId)"
            >
            {{ option.BUCode + " " + option.BucketName + " " + option.Description }}
          </mat-option>
        }
      </mat-select>

      @if (DestinationPackageFolder.hasError('required')) {
        <mat-error>
          <span>Bucket Name is a mandatory field</span>
        </mat-error>
      }

      @if (form.controls.DestinationPackageFolder?.errors?.studiesNotFromSameBU) {
        <mat-error>
          <span>Please select Study Package Folders from the same BU</span>
        </mat-error>
      }

      @if (form.controls.DestinationPackageFolder?.errors?.doesNotHaveStudyAccess) {
        <mat-error>
          <span>You do not have study access in eSM to transfer Study Package(s)</span>
        </mat-error>
      }

      @if (form.controls.DestinationPackageFolder?.errors?.doesNotHavePreArchiveBricsAccess) {
        <mat-error>
          <span>You do not have access to the Pre-Archive Bucket of the Study BU</span>
        </mat-error>
      }

      @if (form.controls.DestinationPackageFolder?.errors?.studyNotMappedToBu) {
        <mat-error>
          <span>Study not mapped to BU</span>
        </mat-error>
      }
    </mat-form-field>
  </form>

  <button
    mat-raised-button
    color="primary"
    class="button_content primary-hover w-p-100"
    id="bucket-items-transfer-btn-submit"
    (click)="transferPackageOnSubmit()"
    >
    Transfer
  </button>

  <button
    mat-button
    class="mat-button button_content w-p-100"
    color="primary"
    id="bucket-items-transfer-btn-cancel"
    (click)="cancel()"
    >
    Cancel
  </button>

</div>
